module.exports = __webpack_public_path__ + "static/kvm_12.e5b6fcba.png";